import React from 'react';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';

const AppTextInput = ({
  type,
  name,
  id,
  fullWidth,
  size,
  value,
  onChange,
  helperText,
  variant,
  error,
  inputProps,
  InputLabelProps,
  style,
  tooltip,
  ...rest
}) => {
  // Include shrink: true in InputLabelProps when the type is "date"
  const modifiedInputLabelProps =
    type === 'date' ? { ...InputLabelProps, shrink: true } : InputLabelProps;


  return (

    tooltip ?
      <Tooltip title={tooltip}>
        <TextField
          {...rest}
          style={style}
          InputLabelProps={modifiedInputLabelProps}
          type={type}
          name={name}
          id={id || name}
          size={size}
          fullWidth={fullWidth}
          value={value}
          variant={variant}
          onChange={onChange}
          error={error || helperText !== ''}
          helperText={helperText}
          inputProps={inputProps}
        />
      </Tooltip>

      :
      <TextField
        {...rest}
        style={style}
        InputLabelProps={modifiedInputLabelProps}
        type={type}
        name={name}
        id={id || name}
        size={size}
        fullWidth={fullWidth}
        value={value}
        variant={variant}
        onChange={onChange}
        error={error || helperText !== ''}
        helperText={helperText}
        inputProps={inputProps}
      />

  );
};

AppTextInput.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  fullWidth: PropTypes.bool,
  value: PropTypes.string,
  variant: PropTypes.string,
  size: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  inputProps: PropTypes.object,
  InputLabelProps: PropTypes.object,
  style: PropTypes.object,
};

AppTextInput.defaultProps = {
  type: 'text',
  fullWidth: true,
  size: 'small',
  error: false,
  helperText: '',
};

export default AppTextInput;
